import {PAYLOAD_FIELDS_NAMES} from '@chekin/api';
import {GUEST_FORM_NAMES, isActiveFormField, type OCRDetectedData} from '@chekin/core';
import type {AddFormType} from './types';

export const UNDER_16_IV_BYPASS_AGE = 16;

const IV_BYPASS_THRESHOLDS: {age: number; payloadField: PAYLOAD_FIELDS_NAMES}[] = [
  {
    age: UNDER_16_IV_BYPASS_AGE,
    payloadField: PAYLOAD_FIELDS_NAMES.is_under_16_iv_bypass_declared,
  },
];

export function getIvBypassPayload(
  declaredIvBypassAge: number | null,
): Record<string, boolean> {
  return IV_BYPASS_THRESHOLDS.reduce<Record<string, boolean>>(
    (payload, threshold) => ({
      ...payload,
      [threshold.payloadField]: declaredIvBypassAge === threshold.age,
    }),
    {},
  );
}

export function getDetectedIvBypassAge(
  data: Pick<OCRDetectedData, 'is_minor'> | null | undefined,
  formFields: AddFormType | undefined,
): number | null {
  if (!data?.is_minor || !isActiveFormField(formFields?.[GUEST_FORM_NAMES.birth_date])) {
    return null;
  }
  return UNDER_16_IV_BYPASS_AGE;
}
